import { Directive, Input, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[regexReplace]'
})
export class RegexReplaceDirective {
  constructor(private model: NgModel) {
  }
  @Input() regexReplace: string | RegExp;
  @HostListener('input', ['$event']) onInput($event) {
    const original = decodeURIComponent((<string>this.model.value));
    const nuevo = original.replace(this.regexReplace, '');
    if (original != nuevo) {
      this.model.valueAccessor.writeValue(nuevo);
    }
  }
}
